/* eslint-disable no-console */
import { useCallback } from "react";
import { ConfirmationStatus } from "../constants";
import { sendUserChoice } from "api";

export const useDialogActions = (state, setState, show) => {
    const handleChoiceSubmitted = useCallback(
        (choice, jsonData = null) => {
            setState((prevState) => ({
                ...prevState,
                status: ConfirmationStatus.SENDING,
            }));
            sendUserChoice(state.dialogData.userChoiceUrl, choice, jsonData)
                .then((response) => {
                    console.debug(
                        `Received response for user-choice '${choice}'.`,
                        response.data,
                    );
                   
                    if (response.data && response.data.followupDialogData) {
                        setTimeout(() => {
                            show(response.data.followupDialogData);
                        }
                        , 500);
                    } else if (state.dialogData.reloadPageAfterScan) {
                        setState((prevState) => ({
                            ...prevState,
                            status: ConfirmationStatus.UPDATING,
                        }));
                        window.location.reload();
                    } else {
                        setState((prevState) => ({
                            ...prevState,
                            status: ConfirmationStatus.CLOSED,
                        }));
                    }
                })
                .catch((error) => {
                    console.error(
                        `Error sending user-choice '${choice}'!`,
                        error,
                    );
                    setState((prevState) => ({
                        ...prevState,
                        status: ConfirmationStatus.ERROR,
                    }));
                });
        },
        [state.dialogData, setState, show],
    );

    const handleClose = useCallback(() => {
        if (state.dialogData.allowClose) {
            setState((prevState) => ({
                ...prevState,
                status: ConfirmationStatus.CLOSED,
            }));
        }
    }, [state.dialogData, setState]);

    return { handleChoiceSubmitted, handleClose };
};
